import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const features = [
  { src: "images/feature-allure.svg", alt: "allure", size : {width:136,height:49}},
  { src: "images/feature-marieclaire.svg", alt: "marieclaire", size : {width:141,height:30} },
  { src: "images/feature-poosh.svg", alt: "poosh", size : {width:122,height:31} },
  { src: "images/feature-womenshealth.svg", alt: "womenshealth", size : {width:150,height:31} },
  { src: "images/feature-forbes.svg", alt: "forbes", size : {width:126,height:29} },
  { src: "images/feature-glamour.svg", alt: "glamour", size : {width:131,height:29} },
];

const Feature = () => {
  return (
    <section className="feature">
      <div className="container-xl">
        <div className="feature_head">FEATURED IN:</div>
        <div className="feature_content">
          <Swiper
            modules={[Navigation, Autoplay]}
            slidesPerView={3}
            spaceBetween={10}
            loop={true}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            speed={800}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            breakpoints={{
              1024: {
                slidesPerView: 6,
              },
              992: {
                slidesPerView: 4,
              },
            }}
          >
            {features.map((feature, index) => (
              <SwiperSlide key={index}>
                <div
                  className="swiper-slide-content"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <img
                    src={feature.src}
                    className="img-fluid"
                    alt={feature.alt}
                    width={feature.size.width}
                    height={feature.size.width}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="swiper-button-wrapper d-block d-lg-none">
            <div className="swiper-button-next"></div>
            <div className="swiper-button-prev"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Feature;
